import { render, staticRenderFns } from "./RequestNotifications.vue?vue&type=template&id=1a269232&"
import script from "./RequestNotifications.vue?vue&type=script&lang=js&"
export * from "./RequestNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports